/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxSedonaHoodW42Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxSedonaHoodW42').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'VENT_HOOD_SVH42',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-sedona-hood-w-42.js.map